import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//
import ContactForm from "../../../components/contact-form/ContactForm";
import IconWrapper from "../../../components/icon-wrapper/IconWrapper";

export default function ContactFormSect() {
  const { t } = useTranslation();

  return (
    <StyledContactFormSect>
      <div className="container">
        <div className="contact-form__wrap">
          <div className="contact-form__left">
            <h1 dangerouslySetInnerHTML={{ __html: t("mainContactTitle") }} />
            <p>{t("mainContactText")}</p>
            <ul>
              <li>
                <IconWrapper />
                <div>
                  <a href="tel:+998954100014">+998 (95) 410 00 14</a>
                  <a href="tel:+998954100014">+998 (95) 410 00 14</a>
                </div>
              </li>
              <li>
                <IconWrapper icon="location" />
                <div>
                  <a
                    href="https://yandex.uz/maps/10334/samarkand/house/Yk8YfwFgQEcDQF1jfXp0dHhmbQ==/?from=mapframe&ll=66.960924%2C39.655460&z=16"
                    target="__blank"
                    className="hover-underline"
                    dangerouslySetInnerHTML={{
                      __html: t("footerAddressText"),
                    }}
                  ></a>
                </div>
              </li>
              <li>
                <IconWrapper icon="mail" />
                <div>
                  <a href="mailto:test@gmail.com">test@gmail.com</a>
                  <a href="mailto:test@gmail.com">test@gmail.com</a>
                </div>
              </li>
            </ul>
          </div>
          <div className="contact-form__right">
            <ContactForm bg="--white" />
          </div>
        </div>
      </div>
    </StyledContactFormSect>
  );
}

const StyledContactFormSect = styled.section`
  padding: 140px 0;

  .contact-form {
    &__wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 100px;
    }

    &__left {
      padding-top: 24px;

      h1 {
        color: var(--title);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: 24px;

        span {
          color: var(--light-blue);
        }
      }

      p {
        color: var(---text);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        text-align: left;
        margin-bottom: 56px;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 32px;

        li {
          display: flex;
          gap: 24px;
          align-items: center;

          div {
            display: flex;
            flex-direction: column;
            gap: 6px;
          }

          a {
            color: var(--title);
            font-size: var(--fs-body);
            font-style: normal;
            font-weight: var(--fw-medium);
            line-height: var(--lh-body);
          }
        }
      }
    }
  }
`;
